const ViewBill = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            Thank You for making a purchase with Elite Weaves!
        </div>
    );
};

export default ViewBill;
